import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

import { navbarData } from './navbar-tab';
import { SharedDataService } from '../../services/shared-data.service';
import { RoutePersistenceService } from '../../services/route-persistence.service';
import { BetaService } from '../../services/beta.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, MatSidenavModule, MatTooltipModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  constructor(
    private sharedDataService: SharedDataService,
    private routePersistenceService: RoutePersistenceService,
    private betaService: BetaService
  ) {}

  collapsed = true;
  navData = navbarData;

  @Output() collapsedChanged = new EventEmitter<boolean>();

  // Filter navigation data based on beta access
  get filteredNavData() {
    return this.navData.filter(item =>
      this.betaService.hasAccessToModule(item.routeLink)
    );
  }

  onExpand() {
    this.collapsed = false;
    this.collapsedChanged.emit(this.collapsed);
  }

  onCollapse() {
    this.collapsed = true;
    this.collapsedChanged.emit(this.collapsed);
  }

  onTabSelect(tab: any) {
    // Update the dashboard state
    this.sharedDataService.updateDashboardState('navBarData', tab);

    // The route will be automatically saved by the RoutePersistenceService
    // when the navigation completes
  }
}
